import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';

// TX-6530: "First Appointment" visual cue. The backend flags an appointment as the
// patient's first visit (no previous non-Cancelled/non-Deleted appointment) via the
// `isFirstVisit` boolean. This synthesises the matching flag so the existing
// icon + tooltip rendering pipeline shows it alongside the server-provided flags.
export const FIRST_APPOINTMENT_FLAG_NAME = 'First Appointment';
export const FIRST_APPOINTMENT_FLAG_ICON = 'assets/icons/valid-values/Color/Flags/first_visit.svg';

export function buildFirstAppointmentFlag(): EnumValidValueItemModel {
  console.log('buildFirstAppointmentFlag');
  const flag = new EnumValidValueItemModel();
  flag.ItemName = FIRST_APPOINTMENT_FLAG_NAME;
  flag.ItemDisplayValue = FIRST_APPOINTMENT_FLAG_NAME;
  flag.IconIDSVG = FIRST_APPOINTMENT_FLAG_ICON;
  return flag;
}

// Parses the server `ApptFlags` JSON string into its `aflag` array and, when the
// appointment is the patient's first visit, prepends the "First Appointment" flag
// (unless the backend already emitted it) so it is never duplicated.
export function loadAppointmentFlags(flags: string, isFirstVisit: boolean = false): EnumValidValueItemModel[] {
  let appointmentFlags: EnumValidValueItemModel[] = [];
  if (flags) {
    const flagsObject = JSON.parse(flags);
    appointmentFlags = flagsObject.aflag || [];
  }

  if (isFirstVisit && !appointmentFlags.some(f => f && f.ItemDisplayValue === FIRST_APPOINTMENT_FLAG_NAME)) {
    console.log('Add isFirstVisit', isFirstVisit);
    appointmentFlags = [buildFirstAppointmentFlag(), ...appointmentFlags];
    console.log('appointmentFlags after adding First Appointment flag', appointmentFlags);
  }

  return appointmentFlags;
}
